import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { navData } from 'src/app/data/nav-data';
import { NavigationNotificationBadgeData } from 'src/app/model/user';
import { AlertsService } from 'src/app/services/alerts.service';
import { CommonService } from 'src/app/services/common.service';
import { FleetReportDvcrService } from 'src/app/services/fleet-report-dvcr.service';
import { MentorLoginReportService } from 'src/app/services/mentor-login-report.service';

@Component({
  selector: 'menu-notification-badge',
  templateUrl: './menu-notification-badge.html',
  styleUrls: ['./menu-notification-badge.scss'],
})
export class MenuNotificationBadgeComponent implements OnInit, OnDestroy {
  @Input() tooltip: string = '';
  @Input() id: string;
  notificationSubscription: Subscription;
  notificationData: NavigationNotificationBadgeData = {
    total: 0,
  };

  /**
   * Creates a new instance of MenuNotificationBadgeComponent
   */
  constructor(
    private cService: CommonService,
    private alertsService: AlertsService,
    private fleetReportDvcrService: FleetReportDvcrService,
    private mentorLoginReportService: MentorLoginReportService
  ) {}

  /**
   * Executes when the component is initialised.
   */
  ngOnInit() {
    this.getNotificationData();

    this.cService.updateMenuBadgeCount$.subscribe((targetBadge) => {
      if (this.id === targetBadge) {
        if (this.notificationSubscription) {
          this.notificationSubscription.unsubscribe();
        }

        this.getNotificationData();
      }
    });
  }

  /**
   * Fetches the notification badge data from a specific subscription depending
   * on the menu item.
   */
  private getNotificationData() {
    let request: Observable<NavigationNotificationBadgeData>;

    if (this.id === navData.dvcr.id) {
      request = this.fleetReportDvcrService.getNotificationCount(
        this.notificationData.dvcrDamageDetailsS1 as number,
        this.notificationData.dvcrDamageDetailsS2 as number
      );
    }

    if (this.id === navData.vrmAlerts.id) {
      request = this.alertsService.getNotificationCount();
    }

    if (this.id === navData.loginLogout.id) {
      request = this.mentorLoginReportService.getNotificationCount();
    }

    if (navData[this.id].menuCountEndpoint) {
      request = this.getTotalFromDedicatedEndpoint();
    }

    if (!request) {
      return;
    }

    this.notificationSubscription = request.subscribe((data) => {
      this.notificationData = data;
    });
  }

  /**
   * Returns the count for the menu badge via a dedicated endpoint from navData,
   * or provided endpoint.
   */
  protected getTotalFromDedicatedEndpoint(endpointOverride?: string): Observable<NavigationNotificationBadgeData> {
    const endpoint: string = endpointOverride ? endpointOverride : navData[this.id].menuCountEndpoint;
    return this.cService.commonGet(endpoint);
  }

  /**
   * Executed when the component is destroyed.
   */
  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }
}
